import { lazy } from "react";
import { usersSvg } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "transmission" */ './components/EntryPoint'));
const UsersLoader = lazy(() => import(/* webpackChunkName: "usersLoader" */ './components/UsersLoader'));
const FormUser = lazy(() => import(/* webpackChunkName: "formUser" */ './components/FormUser'));

export const defaultPath = '/users';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: UsersLoader,
        exact: true,
        icon: usersSvg,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'users_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: FormUser,
        exact: true,
        icon: usersSvg,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'create_user',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: FormUser,
        exact: true,
        icon: usersSvg,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: ' ',
            plural: false
        }
    }
];

const Users = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: usersSvg,
    title: {
        key: 'users',
        plural: false
    },
    subTitle: {
        key: '',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Users;
